import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { LoadingService } from './services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements AfterViewChecked {
  constructor(
    public loadingService: LoadingService,
    private changeDetector: ChangeDetectorRef) { }
  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }
}
